export const header = {
  fontSize: "1.125em",
  lineHeight: "1.4285em",
  color: "rgba(0,0,0,.87)",
  fontWeight: "normal",
};

export const subheader = {
  fontSize: "1.125em",
  lineHeight: "1.4285em",
  color: "rgba(0,0,0,.87)",
  fontWeight: "normal",
  margin: 0,
};

export const description = {
  fontSize: "1.125em",
};

export const extra = {
  color: "rgba(0,0,0,.87)",
  letterSpacing: "0.3px",
  textTransform: "capitalize",
  fontWeight: "700",
  fontSize: "1.5em",
  margin: "2rem 0",
};
